import { AxiosResponse } from "axios";
import { RcFile } from "antd/lib/upload/interface";
import api from "../axiosInstance";

class BopService {
  getBop = async (id: string | number): Promise<AxiosResponse> => {
    const response = await api.get(`bop/${id}`);
    return response;
  };

  getBopAttachments = async (id: string | number): Promise<AxiosResponse> => {
    const response = await api.get(`bop/${id}/attachments`);
    return response;
  };

  getList = async (): Promise<AxiosResponse> => {
    const response = await api.get(`bop`);
    return response;
  };

  create = async (ticket: any): Promise<AxiosResponse> => {
    const response = await api.post(`bop`, ticket);
    return response;
  };

  update = async (id: number | string, ticket: any): Promise<AxiosResponse> => {
    const response = await api.patch(`bop/${id}`, ticket);
    return response;
  };

  createScratchpad = async (
    id: number | string,
    comment: any
  ): Promise<AxiosResponse> => {
    const response = await api.post(`bop/${id}/scratchpad`, comment);
    return response;
  };

  getScratchpad = async (id: number | string): Promise<AxiosResponse> => {
    const response = await api.get(`bop/${id}/scratchpad`);
    return response;
  };

  createComment = async (
    id: number | string,
    comment: any
  ): Promise<AxiosResponse> => {
    const response = await api.post(`bop/${id}/comment`, comment);
    return response;
  };

  getComments = async (id: number | string): Promise<AxiosResponse> => {
    const response = await api.get(`bop/${id}/comments`);
    return response;
  };

  uploadFile = async (
    id: string | number,
    bulkId: string | number,
    file: string | RcFile | Blob,
    onProgressChange: (progress: number) => void
  ): Promise<AxiosResponse> => {
    const formData = new FormData();
    formData.set("file", file);

    const response = await api.post(
      `bop/${id}/attachment/upload/${bulkId}`,
      formData,
      {
        onUploadProgress(progressEvent) {
          const percentCompleted = Math.round(
            (progressEvent.loaded * 100) / progressEvent.total
          );
          onProgressChange(percentCompleted);
        },
      }
    );
    return response;
  };

  uploadAttachment = async (
    file: string | RcFile | Blob,
    onProgressChange: (progress: number) => void
  ): Promise<AxiosResponse> => {
    const formData = new FormData();
    formData.set("file", file);
    const response = await api.post(`/attachments/upload`, formData, {
      onUploadProgress(progressEvent) {
        const percentCompleted = Math.round(
          (progressEvent.loaded * 100) / progressEvent.total
        );
        onProgressChange(percentCompleted);
      },
    });
    return response;
  };

  downloadFile = async (id: string | number): Promise<AxiosResponse> => {
    const response = await api.get(`attachments/download/${id}`, {
      responseType: "blob",
    });

    return response;
  };

  previewFile = async (id: string | number) => {
    const response = await api.get(`attachments/download/${id}`, {
      responseType: "blob",
    });
    const objectUrl = URL.createObjectURL(response.data);
    return objectUrl;
  };
}

export default new BopService();
